export const userQuery = `
    id
    name
    surname
    titleBeforeName
    titleAfterName
`;